
<modal-window :main-width="10">
  <h1>Shift Handover</h1>

  <div class="row" v-show="displayBaseData">
    <div class="col-6 my-auto align-items-center" v-if="!currentShift || !currentShift.supervisor">
      <div class="p-5 text-center font-weight-bold" style="color: #aaa; font-size: 2.5rem">
        <i class="far fa-shapes"></i>
        <br />
        NO CURRENT SHIFT
      </div>
    </div>

    <div class="col-6" v-else>
      <div class="label mt-2 mb-1 text-center">Current Shift</div>
      <hr />

      <div class="label mt-2 mb-1">Supervisor</div>
      <v-select
        :options="availableSupervisors"
        label="displayName"
        :clearable="false"
        :disabled="true"
        :reduce="(user) => user.id"
        placeholder="Please select a supervisor..."
        v-model="currentShift.supervisor.id"
      >
        <template #open-indicator="{}">
          <span></span>
        </template>
      </v-select>

      <div class="label mt-2 mb-1">Shift Type</div>
      <v-select
        :options="shiftTypes"
        label="name"
        :disabled="true"
        :clearable="false"
        placeholder="No shift type was selected"
        v-model="currentShift.shiftType"
      >
        <template #open-indicator="{}">
          <span></span>
        </template>
      </v-select>

      <div class="row">
        <div class="col-6">
          <div class="label mt-2 mb-1">From</div>
          {{ shiftStart }}
        </div>

        <div class="col-6">
          <div class="label mt-2 mb-1">To</div>
          {{ shiftEnd }}
        </div>
      </div>
    </div>

    <div class="col-6">
      <div class="label mt-2 mb-1 text-center">Next Shift</div>
      <hr />

      <div class="label mt-2 mb-1">Supervisor</div>
      <div :class="{ required: !supervisorId }">
        <v-select
          v-model="supervisorId"
          :options="availableSupervisors"
          label="displayName"
          :reduce="(user) => user.id"
          :clearable="false"
          :disabled="false"
          placeholder="Please select a supervisor..."
        ></v-select>
      </div>

      <div class="label mt-2 mb-1">Shift Type</div>
      <v-select
        :options="shiftTypes"
        label="name"
        placeholder="Please select a shift type..."
        :reduce="(shiftType) => shiftType.id"
        @input="changeNextShiftType"
        :clearable="false"
        :value="shiftTypeId"
        :searchable="false"
      ></v-select>

      <div class="row">
        <div class="col-6">
          <div class="label mt-2 mb-1">Next Shift From</div>
          {{ nextShiftStart }}
        </div>

        <div class="col-6">
          <div class="label mt-2 mb-1">To</div>
          {{ nextShiftEnd }}
        </div>
      </div>
    </div>
  </div>

  <div class="row" v-if="displayBaseData">
    <div class="col-12">
      <div class="label mt-2 mb-1">Comment</div>
      <textarea class="form-control" rows="4" v-model="comment"></textarea>
    </div>
  </div>

  <div class="row">
    <div
      class="col-12 text-center mt-2 k-cursor-pointer"
      @click="displayBaseData = !displayBaseData"
      v-b-tooltip.hover
      title="Toggle base data"
    >
      <i class="fa-2x far fa-angle-up" v-if="displayBaseData"></i>
      <i class="fa-2x far fa-angle-down" v-if="!displayBaseData"></i>
      <hr class="m-0" />
    </div>
  </div>

  <div class="row"></div>

  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h2 class="mt-3">Board Items</h2>
      <small>Info: Done items will be archived on Shift Handover, Items in progress will be moved to the Tasks list</small>
    </div>
    <div>
      <select class="form-control" v-model="grouping">
        <option value="category">Group by Category</option>
        <option value="label">Group by Label</option>
      </select>
    </div>
  </div>

  <div style="" class="mt-3">
    <div v-if="!groupedItems.length">
      <div class="p-5 text-center font-weight-bold" style="color: #aaa; font-size: 2.5rem">
        <i class="far fa-shapes"></i>
        <br />
        NO BOARDITEMS
      </div>
    </div>

    <div v-else>
      <table class="table table-condensed table-sm boardItemTable">
        <colgroup>
          <col style="width: 10%" />
          <col style="width: 40%" />
          <col style="width: 40%" />
          <col style="width: 10%" />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Title and Description</th>
            <th>Last Comment</th>
            <th>Daily Report</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(group, index) in groupedItems">
            <tr :key="index" class="groupHeader">
              <td colspan="5">
                <i class="far" :class="group.icon"></i>
                {{ group.title }}
              </td>
            </tr>

            <tr v-for="item in group.items" :key="item.id + group.id">
              <td style="vertical-align: middle" class="pl-5">
                <BoardItemStatus :status="item.boardItemStatus"></BoardItemStatus>
              </td>
              <td>
                <div v-if="grouping == 'label'" class="font-weight-bold">
                  {{ item.categoryName }}
                </div>
                <BoardItemLabels :item="item" class="mt-2"></BoardItemLabels>
                <small>
                  <strong>{{ item.typeName }}</strong>
                </small>
                <br />
                {{ item.title }}
                <br />

                <small>
                  <div v-simplify-html="item.description" />
                </small>
              </td>
              <td>
                <small>
                  {{ item.lastCommentText }}
                </small>
              </td>
              <td>
                <input type="checkbox" @change="changeItem(item.id)" :checked="relevantItemIds.indexOf(item.id) !== -1" />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>

  <template v-slot:sidebar>
    <div class="align-self-end flex-grow-1">
      <button :disabled="!supervisorId || !shiftTypeId" class="btn btn-block btn-sm btn-success" @click="confirmHandover()">
        <i class="far fa-save"></i>
        Handover to next shift
      </button>
    </div>
  </template>
</modal-window>
